import { render, staticRenderFns } from "./SelectWarehouseRestriction.vue?vue&type=template&id=38a32f25&"
import script from "./SelectWarehouseRestriction.vue?vue&type=script&lang=js&"
export * from "./SelectWarehouseRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports